import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=43e03787&"
import script from "./Accordion.vue?vue&type=script&lang=ts&"
export * from "./Accordion.vue?vue&type=script&lang=ts&"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=43e03787&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports